/**
 * Default options for scrolling.
 */
export const DEFAULT_SCROLL_OPTIONS = {
    smoothScroll: true,
    shouldThrowOnBounds: true,
    align: 'auto'
};
